import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import DOMElementRenderer from '../../containers/dom-element-renderer.jsx';
import MonitorList from '../../containers/monitor-list.jsx';
import TargetHighlight from '../../containers/target-highlight.jsx';
import GreenFlagOverlay from '../../containers/green-flag-overlay.jsx';
import Question from '../../containers/question.jsx';
import {STAGE_DISPLAY_SIZES} from '../../lib/layout-constants.js';
import {getStageDimensions} from '../../lib/screen-utils.js';
import styles from './stage.css';
import greenFlag from './icon-pause.svg'
import {setStageCover, setWorkButState} from "../../reducers/vm-status";
import VM from "scratch-vm";

const innerWidth = window.innerWidth;

class StageComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'onHandleStart'
        ]);
    }

    onHandleStart(){
        this.props.vm.greenFlag();
        this.props.setStageCover();
        this.props.setWorkButState(false);
    }

    render() {
        const {
            canvas,
            dragRef,
            isColorPicking,
            isFullScreen,
            isMobile,
            isStarted,
            question,
            stageCover,
            stageSize,
            useEditorDragStyle,
            onDeactivateColorPicker,
            onDoubleClick,
            onQuestionAnswered,
            ...boxProps
        } = this.props;
        const stageDimensions = getStageDimensions(stageSize, isFullScreen);
        const windowWidth = window.innerWidth;

        return (
            <div>
                <Box
                    className={classNames({
                        [styles.stageWrapper]: !isFullScreen,
                        [styles.stageWrapperOverlay]: isFullScreen,
                        [styles.withColorPicker]: !isFullScreen && isColorPicking
                    })}
                    style={{
                        height: '100%',
                        // minWidth: stageDimensions.width
                    }}
                    onDoubleClick={onDoubleClick}
                >
                    <Box
                        className={classNames(
                            styles.stage,
                            {
                                [styles.stageOverlayContent]: isFullScreen,
                                [styles.stageBorderRadius]: !isMobile
                            }
                        )}
                    >
                        <DOMElementRenderer
                            domElement={canvas}
                            style={{
                                height: isMobile ? windowWidth * 3 / 4 : stageDimensions.height,
                                width: isMobile ? innerWidth : stageDimensions.width,
                                display: 'block'
                            }}
                            {...boxProps}
                        />
                    </Box>
                    <Box className={styles.monitorWrapper}>
                        <MonitorList
                            draggable={useEditorDragStyle}
                            stageSize={stageDimensions}
                        />
                    </Box>
                    <Box className={styles.frameWrapper}>
                        <TargetHighlight
                            className={styles.frame}
                            stageHeight={stageDimensions.height}
                            stageWidth={stageDimensions.width}
                        />
                    </Box>
                    {isStarted ? null : (
                        <GreenFlagOverlay
                            className={styles.greenFlagOverlay}
                            wrapperClass={styles.greenFlagOverlayWrapper}
                        />
                    )}
                    <div
                        className={styles.stageBottomWrapper}
                        style={{
                            width: isMobile ? innerWidth : stageDimensions.width,
                            height: isMobile ? innerWidth * 3 / 4 : stageDimensions.height,
                            left: isMobile ? '' : '50%',
                            marginLeft: isMobile ? '' : stageDimensions.width * -0.5
                        }}
                    >
                        {question === null ? null : (
                            <div
                                className={styles.questionWrapper}
                                style={{width: isMobile ? innerWidth : stageDimensions.width}}
                            >
                                <Question
                                    isMobile
                                    question={question}
                                    onQuestionAnswered={onQuestionAnswered}
                                />
                            </div>
                        )}
                    </div>
                    <canvas
                        className={styles.draggingSprite}
                        height={0}
                        ref={dragRef}
                        width={0}
                    />
                </Box>
                {isColorPicking ? (
                    <Box
                        className={styles.colorPickerBackground}
                        onClick={onDeactivateColorPicker}
                    />
                ) : null}

                {stageCover ? (
                    <Box
                        className={styles.greenFlagBox}
                        style={{
                            top: isMobile ? '0' : '48px',
                            height: isMobile ? windowWidth * 3 / 4 : '360px',
                            width: '100%'
                        }}
                    >
                        <div className={styles.imgCenter}>
                            <div className={classNames(styles.greenFlag, {[styles.greenFlagMobile]: isMobile})}
                                 onClick={this.onHandleStart}
                            >
                                <img src={greenFlag} alt=""/>
                            </div>
                        </div>
                    </Box>
                ) : null}
            </div>
        );
    }
}

StageComponent.propTypes = {
    canvas: PropTypes.instanceOf(Element).isRequired,
    dragRef: PropTypes.func,
    isColorPicking: PropTypes.bool,
    isFullScreen: PropTypes.bool.isRequired,
    isStarted: PropTypes.bool,
    onDeactivateColorPicker: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onQuestionAnswered: PropTypes.func,
    question: PropTypes.string,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    useEditorDragStyle: PropTypes.bool,
    isMobile: PropTypes.bool,
    setStageCover: PropTypes.func,
    stageCover: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    setWorkButState: PropTypes.func
};

const mapStateToProps = state => ({
    stageCover: state.scratchGui.vmStatus.stageCover
});

const mapDispatchToProps = dispatch => ({
    setStageCover: () => dispatch(setStageCover()),
    setWorkButState: state => dispatch(setWorkButState(state))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StageComponent);
